module.exports = __webpack_public_path__ + "static/nora-0115af21157d7ad411c1a9176d5075f5.png";